import env from '../config/env';
import axios from 'axios';
import { Auth } from 'aws-amplify';
import { logoutSessionAD } from './sessionAD.helper';

// Cuerpo client_credentials de un juego de credenciales m2m (env.token o env.mds).
const crearParams = ({ clientId, clientSecret, scope }) => {
    const params = new URLSearchParams();
    params.append('client_id', clientId);
    params.append('client_secret', clientSecret);
    params.append('grant_type', 'client_credentials');
    if (scope) { params.append('scope', scope); }
    return params;
}

const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }

const backoffice = { url: env.token.accessTokenUrl, params: crearParams(env.token) };
const mds = { url: env.mds.accessTokenUrl, params: crearParams(env.mds) };

function getTokenService({ url, params }) {
    return new Promise((resolve) => {
        axios.post(url, params, config).then(res => {
            resolve(res);
        }).catch(error => {
            resolve(error);
        });

    });

}
const verifySessionToken = async() => {
    await Auth.currentSession()
    .then(() => {
        //console.log('get current session token in oauth');
    })
    .catch((error) => {
      console.log(error);
      logoutSessionAD();
    });
    
}

// Token para las APIs del backoffice.
export const getToken = async(verifySession) => {
    if(verifySession) { await verifySessionToken(); }
    return getTokenService(backoffice).then((r) => { return r.data; });
}

// Token para el MDS (login, logout, register_user, permissions/allow).
export const getMdsToken = async(verifySession) => {
    if(verifySession) { await verifySessionToken(); }
    return getTokenService(mds).then((r) => { return r.data; });
}